export enum StopTypes {
  all = 'all',
  planned = 'planned',
  unplanned = 'unplanned',
  technical = 'technical',
}
